import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import API from 'api';
import { PostDocumentProps } from 'api/documents';

export const useAddPublicDocumentMutation = (
  options: UseMutationOptions<any, AxiosError<any>, PostDocumentProps>
) =>
  useMutation<any, AxiosError<any>, PostDocumentProps>(
    (data) => API.documents.postDocumentsPublic(data),
    options
  );
